import { useJobStore } from "../../store/Jobs";
import { JobWithShare } from "@/lib/supabase/supabaseTypes";
import { Button as ShadcnButton } from "@/dentlab/src/components/ui/button";
import { Pin as PinIcon, PinOff as PinOffIcon } from "lucide-react";
import { TooltipWrapper } from "../../components/ui/tooltip-wrapper";

export const PinJob: React.FC<{ job: JobWithShare }> = ({ job }) => {
	const { pinJob, unpinJob, pinnedJobs } = useJobStore((state) => ({
		pinJob: state.pinJob,
		unpinJob: state.unpinJob,
		pinnedJobs: state.pinnedJobs,
	}));
	if (!job.id) return null;
	const isPinned = pinnedJobs[job.id];
	return (
		<TooltipWrapper title={isPinned ? "Fixierung entfernen" : "Fixierung hinzufügen"}>
			<ShadcnButton
				onClick={() => {
					if (isPinned) {
						unpinJob(job.id as number);
					} else {
						pinJob(job);
					}
				}}
				size="icon"
				variant="ghost"
				className="w-8 h-8"
				aria-label={isPinned ? "Fixierung entfernen" : "Fixierung hinzufügen"}
			>
				{isPinned ? <PinOffIcon className="w-5 h-5" /> : <PinIcon className="w-5 h-5" />}
			</ShadcnButton>
		</TooltipWrapper>
	);
};
